
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparConeUp as ObiBuoySparConeUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-cone-up.js';
 
 
 

 
 export const ObiBuoySparConeUp = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-cone-up',
   elementClass: ObiBuoySparConeUpElement,
   events: {
     
   }
  });
 
 